import DetectorInterface from './DetectorInterface';

import Email from './detectors/Email';
import ZipCode from './detectors/ZipCode';
import Date from './detectors/Date';
import Integer from './detectors/Integer';
import Numeric from './detectors/Numeric';
import String from './detectors/String';
import Locale from "./detectors/Locale";
import Phone from "./detectors/Phone";

// Processing order is also defined here
// Dynamic class names won't work in production due to code minimization
const classes = [
    {
        class: Date,
        name: 'Date'
    },
    {
        class: Locale,
        name: 'Locale'
    },
    {
        class: Email,
        name: 'Email'
    },
    {
        class: Phone,
        name: 'Phone'
    },
    {
        class: Integer,
        name: 'Integer'
    },
    {
        class: Numeric,
        name: 'Numeric',
    },
    {
        class: String,
        name: 'String'
    },
    {
        class: ZipCode,
        name: 'ZipCode'
    },
];

export default class DetectorFactory {

    /**
     * Get all instances of detectors
     *
     * @returns {Object}
     */
    static getAllInstances(): Object {

        let detectors: Array<DetectorInterface> = [];

        classes.forEach((detector) => {
            detectors.push(new detector.class(detector.name));
        });

        return detectors;
    }
}

